// Push subscription helper — usa VAPID public key dal backend
import { api } from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - base64String.length % 4) % 4);
  const b64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(b64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export async function isPushSupported() {
  return typeof window !== "undefined"
      && "serviceWorker" in navigator
      && "PushManager" in window
      && "Notification" in window;
}

export async function getPushPermission() {
  if (!(await isPushSupported())) return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

async function ensureSWRegistration() {
  if (!("serviceWorker" in navigator)) throw new Error("Service Worker non supportato");
  const reg = await navigator.serviceWorker.ready;
  return reg;
}

export async function isPushActive() {
  if (!(await isPushSupported())) return false;
  const reg = await ensureSWRegistration();
  const sub = await reg.pushManager.getSubscription();
  return !!sub;
}

export async function subscribeToPush() {
  if (!(await isPushSupported())) throw new Error("Push non supportato su questo browser");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permesso notifiche negato");
  const reg = await ensureSWRegistration();
  const { data } = await api.get("/push/vapid-public-key");
  const existing = await reg.pushManager.getSubscription();
  if (existing) await existing.unsubscribe();
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.key),
  });
  const json = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: json.endpoint,
    keys: json.keys,
    expiration_time: json.expirationTime || null,
    user_agent: navigator.userAgent || "",
  });
  return sub;
}

export async function unsubscribeFromPush() {
  if (!(await isPushSupported())) return;
  const reg = await ensureSWRegistration();
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
    await sub.unsubscribe();
  } else {
    await api.post("/push/unsubscribe", {});
  }
}
